import { TextField } from "@mui/material";
import React from "react";
import { AppointmentOverviewContext } from "../context/appointmentOverviewContext";
import SearchControllsProps from "../interface/searchControllsProps";

const TillTimeInput = (): React.JSX.Element => {
  const {
    searchControlls,
    setSearchControlls,
  }: {
    searchControlls: SearchControllsProps;
    setSearchControlls: React.Dispatch<
      React.SetStateAction<SearchControllsProps>
    >;
  } = React.useContext(AppointmentOverviewContext);

  const handleSetToDate = (date: string): void => {
    setSearchControlls({
      ...searchControlls,
      date: { ...searchControlls.date, end: date },
    });
  };

  return (
    <TextField
      disabled={searchControlls.loading}
      fullWidth
      type="date"
      value={searchControlls.date.end}
      onChange={(e: any) => handleSetToDate(e.target.value)}
      id="EndOfQualification"
      label="Termin bis"
      variant="outlined"
    />
  );
};

export default TillTimeInput;
